import { alpha } from '../numbers/index.mjs';
import { percent } from '../numbers/units.mjs';
import { sanitize } from '../utils/sanitize.mjs';
import { isColorString, splitColor } from './utils.mjs';
var hsla = {
  test: /*@__PURE__*/isColorString("hsl", "hue"),
  parse: /*@__PURE__*/splitColor("hue", "saturation", "lightness"),
  transform: function transform(_ref) {
    var hue = _ref.hue,
      saturation = _ref.saturation,
      lightness = _ref.lightness,
      _ref$alpha = _ref.alpha,
      alpha$1 = _ref$alpha === void 0 ? 1 : _ref$alpha;
    return "hsla(" + Math.round(hue) + ", " + percent.transform(sanitize(saturation)) + ", " + percent.transform(sanitize(lightness)) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
  }
};
export { hsla };